import React, {Component} from 'react';
import axios from 'axios';

import {
	Modal, Table, Button, Row, Col, Alert
} from 'react-bootstrap';
import LayoutPrivate from '../../../components/Layout/Private';

import {extendToken, setTitle} from '../../../util/common';

class ListActiveSponsorship extends Component {
	state = {
		success: false,
		proceed: false,
		error: false,
		successDeletion: false,
		proceedDeletion: false,
		errorDeletion: false,
		successCsv: false,
		proceedCsv: false,
		errorCsv: false,
		deleteId: null,
		data: [],
		order: 'created',
		asc: false
	};

	componentDidMount() {
		extendToken();

		setTitle(['Cykliczne wpłaty', 'Aktywne']);

		this.loadData();
	}

	sortable = (type) => {
		this.setState((prevState) => ({
			order: type,
			asc: prevState.order === type ? !prevState.asc : prevState.asc
		}), () => {
			this.loadData();
		});
	};

	loadData = () => {
		this.setState({
			error: false,
			proceed: true,
			success: false
		});

		const {order, asc} = this.state;

		axios.get(`${process.env.REACT_APP_API_URL}/sponsorship/?order=${order}&asc=${asc}`)
			.then((res) => {
				if (res.success) {
					this.setState({
						error: false,
						proceed: false,
						success: true
					});

					this.setState({
						data: res.message
					});

					setTimeout(() => {
						this.setState({
							success: false
						});
					}, 2500);
				} else {
					this.setState({
						error: true,
						proceed: false,
						success: false
					});
				}
			})
			.catch(() => {
				this.setState({
					error: true,
					proceed: false,
					success: false
				});
			});

		return true;
	};

	handleDelete = (deleteId) => {
		this.setState({
			deleteId
		});
	};

	handleDeleteConfirmed = () => {
		const {deleteId, proceedDeletion, proceed} = this.state;

		if (proceedDeletion || proceed) {
			return false;
		}

		this.setState({
			deleteId: null,
			errorDeletion: false,
			proceedDeletion: true,
			successDeletion: false
		});

		axios.delete(`${process.env.REACT_APP_API_URL}/sponsorship/${deleteId}`)
			.then((res) => {
				if (res.success) {
					this.setState({
						errorDeletion: false,
						proceedDeletion: false,
						successDeletion: true
					});

					this.loadData();

					setTimeout(() => {
						this.setState({
							successDeletion: false
						});
					}, 2000);
				} else {
					this.setState({
						errorDeletion: true,
						proceedDeletion: false,
						successDeletion: false
					});
				}
			})
			.catch(() => {
				this.setState({
					errorDeletion: true,
					proceedDeletion: false,
					successDeletion: false
				});
			});

		return true;
	};

	handleDeleteClose = () => {
		this.setState({
			deleteId: null
		});
	};

	getCsv = () => {
		const {proceedCsv} = this.state;

		if (proceedCsv) {
			return false;
		}

		this.setState({
			errorCsv: false,
			proceedCsv: true,
			successCsv: false
		});

		axios.get(`${process.env.REACT_APP_API_URL}/sponsorship/csv`)
			.then((res) => {
				if (res.success) {
					this.setState({
						errorCsv: false,
						proceedCsv: false,
						successCsv: true
					});

					window.location.href = res.message;

					setTimeout(() => {
						this.setState({
							successCsv: false
						});
					}, 2000);
				} else {
					this.setState({
						errorCsv: true,
						proceedCsv: false,
						successCsv: false
					});
				}
			})
			.catch(() => {
				this.setState({
					errorCsv: true,
					proceedCsv: false,
					successCsv: false
				});
			});

		return true;
	};

	render() {
		const {
			data, success, proceed, error, successDeletion, proceedDeletion, errorDeletion, successCsv, proceedCsv, errorCsv, deleteId, order, asc
		} = this.state;

		return (
			<LayoutPrivate>
				<Row>
					<Col>
						<h2 style={{marginBottom: '2rem'}}>Aktywne cykliczne wpłaty</h2>
						{
							errorDeletion && (
								<Alert variant="danger">
									Błąd połączenia z serwerem, obiekt nie został usunięty.
								</Alert>
							)
						}
						{
							proceedDeletion && (
								<Alert variant="warning">
									Trwa usuwanie wybranego obiektu, proszę czekać...
								</Alert>
							)
						}
						{
							successDeletion && (
								<Alert variant="success">
									Obiekt został usunięty poprawnie.
								</Alert>
							)
						}
						{
							errorCsv && (
								<Alert variant="danger">
									Błąd połączenia z serwerem, plik nie został wygenerowany.
								</Alert>
							)
						}
						{
							proceedCsv && (
								<Alert variant="warning">
									Trwa generowanie pliku CSV, proszę czekać...
								</Alert>
							)
						}
						{
							successCsv && (
								<Alert variant="success">
									Plik został wygenerowany.
								</Alert>
							)
						}
						{
							error && (
								<Alert variant="danger">
									Błąd połączenia z serwerem.
								</Alert>
							)
						}
						{
							proceed && (
								<Alert variant="warning">
									Generowanie widoku w toku... System może częściowo nie odpowiadać.
								</Alert>
							)
						}
						{
							success && (
								<Alert variant="success">
									Gotowe, możesz pracować :)
								</Alert>
							)
						}
						<Table striped bordered hover>
							<thead>
								<tr>
									<th colSpan="7" className="buttons">
										<Button variant="primary" href="/charity_action">Przejdź do prowadzonych zbiórek</Button>
										&nbsp;
										<Button variant="primary" href="/sponsorship/unactive">Przejdź do nieaktywnych cyklicznych wpłat</Button>
										&nbsp;
										<Button variant="primary" onClick={this.getCsv}>Pobierz listę jako plik CSV</Button>
									</th>
								</tr>
								<tr>
									<th className="sortable" onClick={() => this.sortable('id')}>
										#
										{order === 'id' && (asc ? '[↑]' : '[↓]')}
									</th>
									<th className="sortable" onClick={() => this.sortable('sponsor_email')}>
										E-mail
										{order === 'sponsor_email' && (asc ? '[↑]' : '[↓]')}
									</th>
									<th className="sortable" onClick={() => this.sortable('charity_action_name')}>
										Zbiórka
										{order === 'charity_action_name' && (asc ? '[↑]' : '[↓]')}
									</th>
									<th className="sortable" onClick={() => this.sortable('price')}>
										Wysokość
										{order === 'price' && (asc ? '[↑]' : '[↓]')}
									</th>
									<th className="sortable" onClick={() => this.sortable('created')}>
										Utworzono
										{order === 'created' && (asc ? '[↑]' : '[↓]')}
									</th>
									<th className="sortable" onClick={() => this.sortable('updated')}>
										Ostatnia wpłata
										{order === 'updated' && (asc ? '[↑]' : '[↓]')}
									</th>
									<th />{/* eslint-disable-line jsx-a11y/control-has-associated-label */}
								</tr>
							</thead>
							<tbody>
								{
									data.map((item) => (
										<tr key={`table_${item.id}`}>
											<td>{item.id}</td>
											<td>{item.sponsor_email}</td>
											<td>{item.charity_action_name}</td>
											<td>
												{item.price}
												zł
											</td>
											<td>{item.created}</td>
											<td>{item.updated}</td>
											<td><button type="button" className="btn btn-sm btn-danger" onClick={() => this.handleDelete(item.id)}>Usuń</button></td>
										</tr>
									))
								}
							</tbody>
						</Table>
					</Col>
				</Row>
				<Modal show={deleteId !== null} onHide={this.handleDeleteClose}>
					<Modal.Header closeButton>
						<Modal.Title>Potwierdź akcję</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>
							Naprawdę chcesz usunąć cykliczną wpłatę #{deleteId}? To spowoduje, że wszystkie przyszłe wpłaty nie zostaną pobrane. Dotychczasowo wpłacone pieniądze zostaną na Twoim koncie i wszystkie informacje w systemie o dotychczasowych wpłatach zostaną.
						</p>
						<Alert variant="warning">
							<strong>Zatrzymaj się na chwilę!</strong> Ta operacja jest nieodwracalna z poziomu panelu administratora. Może ją przywrócić tylko administrator systemu.
						</Alert>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="success" onClick={this.handleDeleteConfirmed}>
							Tak, chcę.
						</Button>
						<Button variant="danger" onClick={this.handleDeleteClose}>
							Nie, nie chcę.
						</Button>
					</Modal.Footer>
				</Modal>
			</LayoutPrivate>
		);
	}
}

export default ListActiveSponsorship;
